import Vue from 'vue'
import Vuex from 'vuex'
import store from './store/store'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Login from './views/Login'
import Poster from './views/Poster'
import DynamicForm from './components/DynamicForm'
import Submit from './components/Submit'
import SubmitSuccess from './components/SubmitSuccess'
// import stripe_checkout from "./components/payment/stripe_checkout";
// import stripe_success from "./components/payment/stripe_success";
import LogoutSubmit from "./views/LogoutSubmit";

Vue.use(Router);
Vue.use(Vuex);

const router = new Router({
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/home',
      component: Home
    },
    {
      path: '/logoutsubmit',
      component: LogoutSubmit
    },
    {
      path: '/poster/:id',
      component: Poster,
      children: [
        {
          path: 'dynamic/:pageid',
          name: 'dynamic',
          component: DynamicForm
        },
        // {
        //   path: 'payment',
        //   component: stripe_checkout,
        // },
        // {
        //   path: 'payment/success',
        //   component: stripe_success,
        // },
        {
          path: 'submit',
          name: 'submit',
          component: Submit
        },
        {
          path: 'preview',
          name: 'preview',
          component: Submit
        },
        {
          path: 'submitsuccess',
          name: 'submitsuccess',
          component: SubmitSuccess
        },
      ]
    },
    {
      path: '*',
      redirect: '/login'
    }
  ],
})

router.beforeEach((to, from, next) => {
  if (to.path != '/login' && to.path != '/logoutsubmit') {
    let token = location.search.match(/token=([^&]*)/) || false;
    if (token[1]) {
      store.state.prefilledToken = token[1];
      window.history.pushState({}, document.title, process.env.VUE_APP_PATH_CONFIG);
      next('/login');
      // localStorage.setItem('x-api-key', token[1]);
      // store.commit('SET_TOKEN', {token: token[1]});
      // store.state.login.success = true;
      // next();
      // Vue.axios.defaults.headers.common['x-api-key'] = token[1];
    } else if (!localStorage.getItem('x-api-key')) {
      localStorage.removeItem('x-api-key');
      localStorage.removeItem('eposter-token');
      store.state.login.success = false;
      next('/login');
    } else if (localStorage.getItem('x-api-key') && localStorage.getItem('eposter-token')) {
      store.state.login.success = true;
      next();
    } else {
      localStorage.removeItem('x-api-key');
      localStorage.removeItem('eposter-token');
      store.state.login.success = false;
      next('/login');
    }
  } else {
    next();
  }
})
export default router
